import Cmp from './ad-cmp-loader';
/**
 * Include advertisement seeding on page.
 *
 */

class AdSeeding {
  constructor() {
    // eslint-disable-next-line camelcase
    const script = document.createElement('script');
    script.async = true;
    script.src = '//d.nativendo.de/cds/delivery/init';

    const cmp = new Cmp();
    // Seeding Alliance is an IAB compliant vendor, so its id is numeric only
    // eslint-disable-next-line max-len
    // NOTE We don't need the vendorId actually as we disregard it, still we submit it for console output
    // TODO Simplify code if it is really that simple that all IAB vendor may be loaded always as
    //  they stick to the IAB settings stored inside __cmp.
    cmp.waitForConsent(script, 371);
  }
}

export default AdSeeding;
